<template>
  <content-box class="change-cancel--wrap" :width="'530px'">
    <h3 class="title">
      {{ $t('plan.cancelChangeConfirm.title') }}
    </h3>
    <div class="description">
      <p v-html="$t('plan.cancelChangeConfirm.description')"></p>
    </div>
    <div class="footer">
      <ul class="footer-desc">
        <li v-html="$t('plan.cancelChangeConfirm.next')"></li>
      </ul>
      <div class="buttons">
        <ui-button @click="onCloseLayer">
          {{ $t('common.confirm') }}
        </ui-button>
      </div>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    ContentBox,
    UiButton
  },
  data () {
    return {
      hasTermsError: false,
      isTermsAgree: false,
      paymentType: 'card',
      chargeAmount: 1,
      period: {
        start: null,
        end: null
      }
    }
  },
  methods: {
    onCloseLayer () {
      this.$emit('closeLayer')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.change-cancel--wrap {
  padding: 30px;
  box-sizing: border-box;

  .title {
    font-size: 15px;
    color: #868686;
  }

  .description {
    text-align: center;
    padding: 32px 30px 30px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    font-size: 20px;
    color: #ec0047;
    margin: 20px 0;
  }

  .footer {
    .footer-desc {
      font-size: 13px;
      line-height: 1.46;
      color: #777777;
      margin: 23px 0;

      li {
        position: relative;
        margin: 7px 10px;
        padding: 0 12px;

        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 7px;
          left: 0;
          width: 3px;
          height: 3px;
          background-color: #888888;
        }
      }
    }

    .buttons {
      margin: 60px 0 -5px 0;
      text-align: center;

      .ui-btn {
        min-width: 90px;
      }
    }
  }
}
</style>
